import React from "react";

export const ALERT_TYPE = {
	SUCCESS: "success",
};

export const Alert = ({
	alertMessage,
	alertType,
	onCloseButtonClick = undefined,
}) => {
	// Zatím převzato přímo z latte šablony, potenciálně v budoucnu bychom mohli
	// nějak sjednotit ty flash message mezi .latte a react částí.
	return (
		<div className="alert-container">
			<div className={`message message--${alertType}`} role="alert">
				<div>{alertMessage}</div>
				<button className="message__icon-wrapper" onClick={onCloseButtonClick}>
					<svg
						width="13"
						height="13"
						viewBox="0 0 13 13"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<g clipPath="url(#clip0_15_726)">
							<path
								d="M6.5 0C4.77609 0 3.12279 0.68482 1.90381 1.90381C0.68482 3.12279 0 4.77609 0 6.5C0 8.22391 0.68482 9.87721 1.90381 11.0962C3.12279 12.3152 4.77609 13 6.5 13C8.22391 13 9.87721 12.3152 11.0962 11.0962C12.3152 9.87721 13 8.22391 13 6.5C13 4.77609 12.3152 3.12279 11.0962 1.90381C9.87721 0.68482 8.22391 0 6.5 0V0ZM6.5 11.7812C5.09933 11.7812 3.75602 11.2248 2.76559 10.2344C1.77517 9.24398 1.21875 7.90067 1.21875 6.5C1.21875 5.09933 1.77517 3.75602 2.76559 2.76559C3.75602 1.77517 5.09933 1.21875 6.5 1.21875C7.90067 1.21875 9.24398 1.77517 10.2344 2.76559C11.2248 3.75602 11.7812 5.09933 11.7812 6.5C11.7812 7.90067 11.2248 9.24398 10.2344 10.2344C9.24398 11.2248 7.90067 11.7812 6.5 11.7812Z"
								fill="#FFFF00"
							></path>
							<path
								d="M8.53125 3.25L6.5 5.28125L4.46875 3.25L3.25 4.46875L5.28125 6.5L3.25 8.53125L4.46875 9.75L6.5 7.71875L8.53125 9.75L9.75 8.53125L7.71875 6.5L9.75 4.46875L8.53125 3.25Z"
								fill="#FFFF00"
							></path>
						</g>
						<defs>
							<clipPath id="clip0_15_726">
								<rect width="13" height="13" fill="white"></rect>
							</clipPath>
						</defs>
					</svg>
				</button>
			</div>
		</div>
	);
};
